import { useState } from "react";
import { useInterval } from "usehooks-ts";
export const useCurrentTime = (delay = 1000) => {
    const [now, setNow] = useState(new Date());
    useInterval(() => {
        setNow(new Date());
    }, delay);
    return now;
};
//# sourceMappingURL=useCurrentTime.js.map